import React, { useState } from 'react';
import clsx from 'clsx';
import { pressedButtonsOptions } from './pressedButtonsOptions';
import { useStyles } from './styles';

function InputNumber({ quantityCocktail, handleButtonClick }) {
  const classes = useStyles();

  const [pressedBtnMap, setPressedBtnMap] = useState({
    pressedBtn: '',
    isPressedBtn: false,
  });

  const handlePressedBtn = pressedBtnData => () => {
    setPressedBtnMap(pressedBtnData);
  };

  const pressedMinusButton =
    pressedBtnMap.isPressedBtn && pressedBtnMap.pressedBtn === 'minus';

  const pressedPlusButton =
    pressedBtnMap.isPressedBtn && pressedBtnMap.pressedBtn === 'plus';

  return (
    <div className={classes.inputNumberContainer}>
      <button
        className={clsx(
          classes.button,
          classes.decrementButton,
          pressedMinusButton && classes.pressedButton,
        )}
        onClick={handleButtonClick('minus')}
        onMouseDown={handlePressedBtn(pressedButtonsOptions.minusBtnPressed)}
        onMouseUp={handlePressedBtn(pressedButtonsOptions.minusBtnReleased)}
        onTouchStart={handlePressedBtn(pressedButtonsOptions.minusBtnPressed)}
        onTouchEnd={handlePressedBtn(pressedButtonsOptions.minusBtnReleased)}
      >
        -
      </button>
      <div className={classes.quantity}>
        <span>{quantityCocktail}</span>
      </div>
      <button
        className={clsx(
          classes.button,
          classes.incrementButton,
          pressedPlusButton && classes.pressedButton,
        )}
        onClick={handleButtonClick('plus')}
        onMouseDown={handlePressedBtn(pressedButtonsOptions.plusBtnPressed)}
        onMouseUp={handlePressedBtn(pressedButtonsOptions.plusBtnReleased)}
        onTouchStart={handlePressedBtn(pressedButtonsOptions.plusBtnPressed)}
        onTouchEnd={handlePressedBtn(pressedButtonsOptions.plusBtnReleased)}
      >
        +
      </button>
    </div>
  );
}

export default InputNumber;
